import React from "react";
import { CompanyPreview } from "../Company/CompanyPreviewPanel";

interface CompanyForContactPreviewPanelProps {
  company: server.dto.CompanyWithWorkRelation
}

export const CompanyForContactDetails = ({ company: companyWithWorkRelation }: CompanyForContactPreviewPanelProps) => {
  return <CompanyPreview
    companyId={companyWithWorkRelation.company.companyId}
    trigger={<div className="preview-panel-list-item hoverable flex-column">
      <div>{companyWithWorkRelation.company.name}</div>
      <div className="text-sublabel">{companyWithWorkRelation.company.cityCountry}</div>
    </div>}
  />
}